export default __webpack_public_path__ + "static/media/picto_3.ee4c8391.png";